// Websocket client
if (mpro.config.websocket.enabled === true) {
	import('../vendor/socketcluster.js');
	import('../mpro/modules/mpro.ws-client.js');
}

export default {};